import { render } from "./demoBlock.vue?vue&type=template&id=539a4fac"
import script from "./demoBlock.vue?vue&type=script&lang=js"
export * from "./demoBlock.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/RelaxPlus/RelaxPlus/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__